import { META_IMAGES, OG_IMAGES } from '@/v2/constants/images/meta'
import { AUTH_ROUTES, PUBLIC_MAIN_ROUTES } from '@/v2/constants/routes'
import { OGImageType } from '@/v2/types/meta'

export const ogImages: OGImageType[] = [
  {
    url: OG_IMAGES.BASE_URL.concat('/ski-gear-shipping.jpg'),
    alt: 'ski gear shipping page og',
    width: 1200,
    height: 630
  }
]

export const metaImages: OGImageType[] = [
  {
    url: META_IMAGES.DEFAULT,
    alt: 'ski gear shipping page search image',
    width: 92,
    height: 92
  },
  ...ogImages
]

export const heroSectionContent = {
  title: 'Ski Gear <span>Shipping</span> Made Simple',
  description:
    'Leave the stress of carrying heavy ski bags behind. With ShipAndStorage, enjoy reliable shipping services.',

  ctaButton: { href: AUTH_ROUTES.REGISTER.href, text: 'Ship Ski Now' }
}

export const whyWeSectionContent = {
  title: 'How We Ship Ski Gear',
  ctaButton: { href: PUBLIC_MAIN_ROUTES.BOOK_STORAGE_FACILITY.href, text: 'Ship Your Ski' },

  cards: [
    {
      id: 1,
      title: 'Book Online',
      description: 'Sign up and place an order through our easy-to-use pricing page.',
      image: {
        src: '/images/v2/pages/main-pages/ski-gear-shipping/book-online.svg',
        alt: 'Book Online service'
      }
    },
    {
      id: 2,
      title: 'Pack & Label',
      description: 'Follow our detailed packing and labeling instructions to ensure safe transit.',
      image: {
        src: '/images/v2/pages/main-pages/ski-gear-shipping/pack-label.svg',
        alt: 'Pack & Label service'
      }
    },
    {
      id: 3,
      title: 'Pickup or Drop-Off',
      description: 'You can either choose from doorstep pickup or drop-off at a carrier location.',
      image: {
        src: '/images/v2/pages/main-pages/ski-gear-shipping/pickup-or-drop-off.svg',
        alt: 'Pickup or Drop-Off service'
      }
    },
    {
      id: 4,
      title: 'Enjoy Your Trip',
      description: 'Get your ski gear delivered right on time and hit the slopes without any stress.',
      image: {
        src: '/images/v2/pages/main-pages/ski-gear-shipping/enjoy-your-trip.svg',
        alt: 'Enjoy Your Trip service'
      }
    }
  ]
}

export const forWhoSectionContent = {
  title: 'Why Ship Your Ski Gear with Us?',

  cards: [
    {
      id: 1,
      title: 'Save Time & Money',
      description: 'Avoid baggage claim hassle and save on airline fees with convenient ski gear shipping.',
      image: {
        src: '/images/v2/pages/main-pages/ski-gear-shipping/save-time-money.svg',
        alt: 'Save Time & Money service'
      }
    },
    {
      id: 2,
      title: 'On-Time Delivery',
      description:
        'Your ski gear arrives securely and punctually, ensuring you’re ready to hit the slopes hassle-free.',
      image: {
        src: '/images/v2/pages/main-pages/ski-gear-shipping/on-time-delivery.svg',
        alt: 'On-Time Delivery service'
      }
    },
    {
      id: 3,
      title: 'Complimentary Insurance',
      description:
        'Enjoy up to $250 insurance coverage, protecting your valuable ski equipment throughout its entire journey.',
      image: {
        src: '/images/v2/pages/main-pages/ski-gear-shipping/complimentary-insurance.svg',
        alt: 'Complimentary Insurance service'
      }
    },
    {
      id: 4,
      title: 'Flexible Pickup Options',
      description:
        'Choose door-to-door pickup or drop-off at carrier locations for ultimate convenience and flexibility.',
      image: {
        src: '/images/v2/pages/main-pages/ski-gear-shipping/flexible-pickup-options.svg',
        alt: 'Flexible Pickup Options service'
      }
    },
    {
      id: 5,
      title: 'Real-Time Tracking',
      description: 'Track your shipment’s journey in real-time for complete transparency and peace of mind.',
      image: {
        src: '/images/v2/pages/main-pages/ski-gear-shipping/real-time-tracking.svg',
        alt: 'Real-Time Tracking service'
      }
    },
    {
      id: 6,
      title: 'Up To Six Months Storage',
      description:
        'Store ski gear in secure, climate-controlled facilities free up to six months between your adventures.',
      image: {
        src: '/images/v2/pages/main-pages/ski-gear-shipping/up-to-six-months-storage.svg',
        alt: 'Up To Six Months Storage service'
      }
    }
  ]
}

export const helperSectionContent = {
  title: 'Packing & Labeling Instructions for Ski Gear',

  articles: [
    {
      content: [
        {
          title: 'Packing Guidelines:',
          points: [
            'Wrap skis in bubble wrap to prevent scratches.',
            'Use a soft or hard ski travel bag for added protection.',
            'Secure your bag with straps or buckles.',
            'Lock your bag using TSA-approved locks for domestic shipments or cable ties for international ones.'
          ]
        }
      ],
      image: {
        src: '/images/v2/pages/main-pages/ski-gear-shipping/packing-guidelines.jpg',
        alt: 'Packing Guidelines'
      }
    },
    {
      content: [
        {
          title: 'Labeling Tips:',
          points: [
            'Place the shipping label inside a label pouch with the barcode visible.',
            'Secure the label pouch to the top handle of your ski bag.',
            'Include an additional copy of the label inside the bag.',
            'Take a photo of the fully labeled bag with the tracking barcode visible for your records.'
          ]
        }
      ],
      image: {
        src: '/images/v2/pages/main-pages/ski-gear-shipping/labeling-tips.jpg',
        alt: 'Labeling Tips'
      }
    }
  ]
}

export const benefitsSectionContent = {
  title: 'Our Ski Gear Shipping Options',
  ctaButton: { href: AUTH_ROUTES.REGISTER.href, text: 'Ship Ski Gear Now' },

  cards: [
    {
      id: 1,
      title: 'Ski Boot Bag',
      points: [
        '<strong>Max Weight: </strong> 25 lbs (11 kg)',
        '<strong>Max Length:</strong> 20 inches (51 cm)',
        '<strong>Max Girth:</strong> 58 inches (148 cm)'
      ],
      image: {
        src: '/images/v2/pages/main-pages/ski-gear-shipping/ski-boot-bag.png',
        alt: 'Ski Boot Bag service'
      }
    },
    {
      id: 2,
      title: 'Single Ski Bag',
      points: [
        '<strong>Max Weight:</strong> 25 lbs (11 kg)',
        '<strong>Max Length:</strong> 73 inches (186 cm)',
        '<strong>Max Girth:</strong> 32 inches (82 cm)'
      ],
      image: {
        src: '/images/v2/pages/main-pages/ski-gear-shipping/single-ski-bag.png',
        alt: 'Single Ski Bag service'
      }
    },
    {
      id: 3,
      title: 'Double Ski Bag',
      points: [
        '<strong>Max Weight:</strong> 40 lbs (18 kg)',
        '<strong>Max Length:</strong> 76 inches (193 cm)',
        '<strong>Max Girth:</strong> 44 inches (112 cm)'
      ],
      image: {
        src: '/images/v2/pages/main-pages/ski-gear-shipping/double-ski-bag.png',
        alt: 'Double Ski Bag service'
      }
    }
  ]
}

export const promotionalBannerSectionContent = {
  id: 1,
  title: 'Get Started with Ski Gear Shipping Today',
  description:
    'Avoid the hassle of traveling with ski gear. ShipAndStorage provides secure, affordable, and reliable ski gear shipping services so you can focus on what matters—hitting the slopes.',
  image: {
    src: '/images/v2/pages/main-pages/ski-gear-shipping/promotional-banner-image.svg',
    alt: 'Get Started with Ski Gear Shipping Today'
  },
  ctaButton: { href: PUBLIC_MAIN_ROUTES.BOOK_STORAGE_FACILITY.href, text: 'Get Started Now' }
}

export const faqSectionContent = {
  title: 'Frequently Asked Questions',

  questions: [
    {
      id: 1,
      question: 'How long does it take to ship my skis?',
      answer:
        'Most domestic shipments take 1-3 business days. International shipping times vary by location, typically 5-7 business days.'
    },
    {
      id: 2,
      question: 'What happens if my ski gear is damaged during shipping?',
      answer:
        'Every shipment includes up to $250 in free insurance. Additional coverage is available for added protection.'
    },
    {
      id: 3,
      question: 'Can I store my skis with you between trips?',
      answer: 'Yes! We offer secure storage for up to 6 months, free of charge.'
    },
    {
      id: 4,
      question: 'How do I pack my skis for shipping?',
      answer: 'Follow our detailed packing guidelines to ensure safe transit.'
    },
    {
      id: 5,
      question: 'What size ski bags do you accept?',
      answer: 'We accommodate ski boot bags, single ski bags, and double ski bags within our size and weight limits.'
    }
  ]
}
